.container
    .row
        .col-md-6.col-md-offset-3

            .quickstart-page.text-center
                a(href='http://www.appcues.com')
                    img.logo(src='/images/logo-white.png', height='40')
